import React from "react";
import { formatEventDate } from "../../content/events";

const EventCard = ({ event, headingLevel: Heading = "h3" }) => (
  <article className="mrf-card">
    <Heading className="mrf-card__title">{event.title}</Heading>
    <ul className="mrf-event__meta">
      <li><strong>When:</strong> {formatEventDate(event)}</li>
      <li><strong>Host:</strong> {event.host}</li>
      <li><strong>Where:</strong> {event.location}</li>
    </ul>
    {event.summary && <p className="mrf-card__body">{event.summary}</p>}
    <a
      className="mrf-btn mrf-btn--primary"
      href={event.registrationUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ alignSelf: "flex-start" }}
    >
      Register<span className="visually-hidden"> for {event.title} (opens in a new tab)</span>
    </a>
  </article>
);

export default EventCard;
